export default defineNuxtRouteMiddleware(async (_to, _from) => {
  const claimLabInfo = await $fetch('/api/claim-lab')

  if (!claimLabInfo.enabled) {
    return abortNavigation()
  }
})
